import React from "react";
import { useDispatch } from "react-redux";
import { Table } from "reactstrap";
// import { deleteNotificationById } from './redux/dispatcher';
import alertNotificationImg from "../../assets/img/alertnotification.png";
import dangerNotificationImg from "../../assets/img/dangernotification.png";
import dayjs from "dayjs";
import { Avatar } from "@mui/material";

function SingleNotification({ setSelectedNotification, data }) {
  const dispatch = useDispatch();
  // console.log(data)
  const handleNotificationDelete = (id) => {
    // dispatch(deleteNotificationById(id));
  };

  // Define background colors for different message types
  const getBackgroundColor = (type) => {
    switch (type) {
      case "alert":
        return "rgba(255, 255, 255, 1)";
      case "danger":
        return "rgba(255, 255, 255, 1)";
      default:
        return "rgba(255, 255, 255, 1)"; // Default light gray with opacity
    }
  };

  // Define text colors for different message types
  const getTextColor = (type) => {
    switch (type) {
      case "alert":
        return "rgba(183, 110, 0, 1)"; // Light red for alert
      case "danger":
        return "rgba(183, 29, 24, 1)"; // Darker yellow for warning
      default:
        return "#333"; // Default dark gray for other types
    }
  };

  // Define text colors for different message types
  const getborder = (type) => {
    switch (type) {
      case "alert":
        return "1px solid rgba(255, 171, 0, 1)"; // Light red for alert
      case "danger":
        return "1px solid rgba(255, 86, 48, 1)";
      default:
        return "1px solid rgba(255, 171, 0, 0.16)";
    }
  };

  const backgroundColor = getBackgroundColor(data?.type);
  const textColor = getTextColor(data?.type);
  const borderDesign = getborder(data?.type);
  const dateTime = dayjs(data?.created_at);

  return (
    <Table>
      <tbody>
        <tr
          style={{
            display: "flex",
            flexDirection: "column",
            marginRight: 12,
            marginLeft: 12,
            marginBottom: 10,
          }}
          className="align-middle"
        >
          <td
            style={{
              padding: "8px",
              border: borderDesign,
              borderRadius: "8px",
              backgroundColor: backgroundColor,
              width: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                width: "100%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "left",
                  whiteSpace: "pre-wrap",
                  wordWrap: "break-word",
                  fontWeight: "600",
                  fontSize: "16px",
                  width: "85%",
                  color: textColor,
                }}
              >
                {/* {
                data?.type !=='alert' ? <i className="fa-solid fa-triangle-exclamation" style={{ color: "#FFAB00", marginRight: '8px', fontSize:'18px' }}></i> : <i class="fa-solid fa-circle-exclamation" style={{ color: "#FF5630", marginRight: '8px', fontSize:'18px' }}></i>
                } */}
                {data?.type === "alert" ? (
                  <img src={alertNotificationImg} alt="" className="mr-3" />
                ) : (
                  <img src={dangerNotificationImg} alt="" className="mr-3" />
                )}
                <div style={{ display: "flex", flexDirection: "column", width: "100%" }} >
                  <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", gap: "1rem", width: "100%", marginBottom: "6px" }} >
                    <div style={{ fontSize: "0.95rem" }} >
                      {data?.company_name}
                    </div>
                    <div style={{ fontSize: "0.95rem" }} >
                      {data?.serial_number}
                    </div>
                    <div style={{ fontSize: "0.95rem" }} >
                      {data?.reason}
                    </div>

                  </div>
                  <div style={{ flexDirection: "column", gap: 5 }}>
                    <div>
                      {data?.message}
                    </div>

                    <div>
                      {data?.created_by != "system" ? `-Checked by: ${data?.first_name} ${data?.last_name}` : `Reported By: System`}
                    </div>
                    <div >
                      {data?.specified_value && <div>Specified Value: {data.specified_value}</div>}
                      {data?.observed_value && <div>Observed Value: {data.observed_value}</div>}
                    </div>
                  </div>
                </div>
              </div>
              {data?.created_at && (
                <div
                  style={{
                    fontWeight: "350",
                    fontSize: "12px",
                    paddingLeft: "4px",
                    display: "flex",
                    flexDirection: "column",
                    textAlign: "end",
                    width: "15%",
                  }}
                >
                  <div>{dateTime.format("HH:mm")}</div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      gap: 30,
                      justifyContent: "end",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        cursor: "pointer",
                      }}
                      onClick={() => setSelectedNotification(data.id)}
                    >
                      {data?.image_urls?.map(
                        (image, index) =>
                          image &&
                          index < 3 && (
                            <Avatar
                              key={image}
                              alt="image"
                              src={image}
                              sx={{
                                width: 25,
                                height: 25,
                                border: 1,
                                borderColor: "gray",
                                marginRight: -5.5,
                              }}
                            />
                          )
                      )}
                    </div>
                    <div>{dateTime.format("DD-MM-YYYY")}</div>
                  </div>
                </div>
              )}
            </div>
          </td>
        </tr>
      </tbody>
    </Table>
  );
}

export default SingleNotification;
